export const LANGUAGES = {
  EN: { code: 'EN', label: 'English', dir: 'ltr' },
  AR: { code: 'AR', label: 'العربية', dir: 'rtl' }
};

export const CATEGORIES = [
  { value: 'all' },
  { value: 'abaya' },
  { value: 'babies' },
  { value: 'beauty' },
  { value: 'bookings' },
  { value: 'cars' },
  { value: 'coffeeAndSweets' },
  { value: 'delivery' },
  { value: 'electronics' },
  { value: 'fashion' },
  { value: 'flowers' },
  { value: 'furniture' },
  { value: 'games' },
  { value: 'gifts' },
  { value: 'groceries' },
  { value: 'health' },
  { value: 'home' },
  { value: 'jewelry' },
  { value: 'oud' },
  { value: 'perfumes' },
  { value: 'pet' },
  { value: 'restaurants' },
  { value: 'services' },
  { value: 'shoes' },
  { value: 'sports' },
  { value: 'water' }
];